// import React from 'react';

const PricingInfo = () => {
    return <p className='pricing-info'>Prix nets en euros - Service compris</p>;
};

export default PricingInfo;
